<template lang="pug">
footer.main(v-if="enabled")
    .container
        .imprint
            span.footer-text {{ imprint }}
</template>
<script>
export default {
    name: 'MainFooter',

    props: {
        config: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            enabled: this.config.theme.hide_footer === false
        };
    },

    computed: {
        imprint() {
            const { languages } = this.config.event_details;
            const { footer_text_i18n = {}, footer_text } = this.config.theme;
            const locale = this.$i18n.locale;
            const defaultLang = this.config.event_details.languages?.[0] || 'en';

            // we currently use different properties to store footer for single/multiple language events
            if (languages.length > 1) {
                return footer_text_i18n[locale] || footer_text_i18n[defaultLang];
            } else {
                return footer_text;
            }
        }
    },
};
</script>
